<!-- CountdownTimer.vue -->
<template>
    <span :class="{ 'urgent': seconds <= 3600 }">
        {{ displayTime }}
    </span>
</template>

<script>
    export default {
        name: 'CountdownTimer',
        props: {
            seconds: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                displayTime: '',
                timer: null
            }
        },
        watch: {
            seconds: {
                immediate: true,
                handler(newVal) {
                    this.updateDisplay(newVal);
                    this.startTimer();
                }
            }
        },
        mounted() {
            this.startTimer();
        },
        beforeDestroy() {
            this.clearTimer();
        },
        methods: {
            formatTime(seconds) {
                if (seconds <= 0) return '已结束';
                if (seconds >= 86400) { // 24 * 60 * 60
                    const days = Math.floor(seconds / 86400);
                    const hours = Math.floor((seconds % 86400) / 3600);
                    const minutes = Math.floor((seconds % 3600) / 60);
                    const secs = seconds % 60;
                    return `${days}天 ${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(secs)}`;
                } else {
                    const hours = Math.floor(seconds / 3600);
                    const minutes = Math.floor((seconds % 3600) / 60);
                    const secs = seconds % 60;
                    return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(secs)}`;
                }
            },

            padZero(num) {
                return num.toString().padStart(2, '0');
            },

            updateDisplay(seconds) {
                this.displayTime = this.formatTime(seconds);
            },

            startTimer() {
                this.clearTimer();

                if (this.seconds > 0) {
                    this.timer = setInterval(() => {
                        const now = Math.max(0, this.seconds - 1);
                        this.$emit('update:seconds', now);
                        this.updateDisplay(now);
                    }, 1000);
                }
            },

            clearTimer() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }
        }
    }
</script>

<style scoped>
    .urgent {
        color: #f56c6c;
        font-weight: bold;
    }
</style>